export enum ManageSettings {
  purposeConsents = 'purposeConsents',
  purposeLegitimateInterests = 'purposeLegitimateInterests',
  specialFeatureOptins = 'specialFeatureOptins'
}